// Import necessary libraries and styles
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import image1 from '../images/startup1.png';
import image2 from '../images/startup2.png';

import image5 from '../images/startup5.png';
//import image3 from '../images/startup3.png';
//import image4 from '../images/startup4.png';

const ThirdSection = () => {
  const images = [image1, image2, image5];

  const Mylinks = [
    'https://olewin-ai.web.app/', 
    'https://olewintechsolutions.com', 
    'https://olewin-academy.web.app'
    
  ];


  const programs = [
    {
      title: "Quantum Computing & AI-Engineer Solutions",
      description: "Leveraging Quantum Computing and AI to develop cutting-edge Web/Mobile Applications for the IT , Energy and pharmaceutical industries. Focused on optimizing complex computations and accelerating innovation in Multiple sectors.",
      
    },
    
    {
      title: "SaaS, Web/Mobile, Blockchain Apps & Service Company",
      description: "Designing robust SaaS platforms and building secure Web and Mobile applications, utilizing Blockchain technology for decentralized, transparent, and scalable data management. Ideal for businesses seeking secure and cloud-based solutions.",
   
    },

    
    {
      title: 'Youtube Tutorials, AI - Web Application for Tech  ',
      description: 'Explore our comprehensive tutorials designed to empower learners at every level. Build real-world projects, stay updated with the latest digital trends, and take your tech skills to the next level. Subscribe today to stay ahead in the tech world!',
   
      
    },

    // {
    //   title: 'Robotics, IoT, AR-VR',
    //   description: 'Explore automation with technology integrated circuits, IoT, and immersive AR/VR experiences.',
    // },
    // {
    //   title: 'Networking & Marketing Media',
    //   description: 'Creating social networking platforms with digital marketing strategies.',
    // },
    
  ];

  return (


    <div className="container-fluid py-5" style={{ backgroundColor: 'black', color: 'white' }}>
    <h2 className="text-center fw-bold mb-5">Startup & Initiatives</h2>
    <p className="text-light fw-bold text-center mx-auto col-9">
      Empowering innovation through cutting-edge technology and entrepreneurial spirit. Our startups and initiatives
      drive transformative solutions in AI, Quantum Computing, Blockchain, IoT, and immersive AR/VR experiences for a
      brighter future.
    </p>
    <hr style={{ borderColor: 'white' }} />
    <div className="row justify-content-center" style={{ padding: '0 3%' }}>
      {programs.map((program, index) => (
        <div key={index} className="col-lg-4 col-md-6 col-12 mb-4">
          <Card style={{ height: '100%', backgroundColor: 'white' }} className="h-100">
            <Card.Img
              variant="top"
              src={images[index % images.length]}
              style={{ height: '180px', objectFit: 'cover' }}
            />
            <Card.Body>
              <Card.Title className="text-dark fw-bold">{program.title}</Card.Title>
              <Card.Text className="text-dark">{program.description}</Card.Text>
              <Button 
                variant="primary" 
                className="mx-auto d-block"
                onClick={() => window.open(Mylinks[index % Mylinks.length], '_blank')}
              >
                Visit Website
              </Button>
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
  </div>


  );
};

export default ThirdSection;


